import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DndAnswerContext from 'components/common/Context';
import DropZone from '../DropZone';
import DraggableChoice from '../DraggableChoice';

const DropZoneWithDraggableChoices = ({
  id, isAnswerKeyView, isCorrect, isComplete, isDragDisabled, dropZones, answerChoices, draggableChoices,
}) => {
  const { hasReusableAnswerChoices } = useContext(DndAnswerContext);
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const current = ref && ref.current;
    if (!current) return;

    setWidth(current.clientWidth);
    setHeight(current.clientHeight);
  }, [ref && ref.current, setWidth, setHeight]);

  return (
    <div>
      <DropZone
        key={id}
        dropZoneRef={ref}
        id={id}
        isCorrect={isCorrect}
        isDropDisabled={isCorrect || isDragDisabled}
        useAnswerStyles={isComplete || isCorrect}
        {...dropZones[id]}
      >
        {(answerChoices[id] || []).map((choiceId, index) => {
          if (!draggableChoices[choiceId]) return null;

          return (
            <DraggableChoice
              key={`${choiceId}-${index}`}
              isDragged
              isRemainingChoice
              showAccessibilityStyling
              dragZoneHeight={height}
              dragZoneWidth={width}
              id={choiceId}
              isAnswerKeyView={isAnswerKeyView}
              isCorrect={isCorrect}
              isDragDisabled={isCorrect || isDragDisabled}
              sourceDropZoneId={hasReusableAnswerChoices ? id : undefined}
              title={draggableChoices[choiceId].title}
              useAnswerStyles={isComplete || isCorrect}
              vocabId={draggableChoices[choiceId].vocabId}
            />
          );
        })}
      </DropZone>
    </div>
  );
};

DropZoneWithDraggableChoices.propTypes = {
  answerChoices: PropTypes.object.isRequired,
  draggableChoices: PropTypes.object.isRequired,
  dropZones: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  isAnswerKeyView: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  isDragDisabled: PropTypes.bool.isRequired,
};

export default DropZoneWithDraggableChoices;
